import { DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";
import { IOfficer } from "./IOfficer";

export interface IUser {
  id?: number;
  login: string;
  fullName?: string;
  birthDate?: Date;
  phoneNumber: string;
  cpfCnpj: string;
  type?: UserType;
  officer?: IOfficer;
  active?: boolean;
  isSendMail?: boolean;
}

export type IPrecatorioApplicantLink = "Undefined" | "Owner" | "Heir" | "Inventorian";

export enum PrecatorioInput {
  Portal = "Portal",
  Dap = "Dap",
  Admin = "Admin",
  OfficerManual = "OfficerManual",
  Migalhas = "Migalhas"
}

export interface IOperationCost {
  accrual: string;
  acquisitionVal: string;
  commission: string;
  cost: string;
  disbursementCost: string;
  dtExpiry: string;
  dtStart: string;
  finalPrice: string;
  id: number;
  operationCost: string;
  pss: string;
  registryCost: string;
  settlementCostValue: string;
  totalExpenses: string;
  uniproof: string;
}

export interface IdocumentMinify {
  id: number;
  file: string;
  category: string | DocumentCategoryEnum;
  fileName: string;
  tradeID: number;
}

export enum StorageType {
  S3,
  Link
}

export type ITradeType = "Undefined" | "OnLine" | "OffLine";

export enum TradePhaseDesc {
  Undefined = "Undefined",
  SellChoice = "SellChoice",
  DocumentValidation = "Validação de Documento",
  DocumentApproval = "Aprovação de Documento",
  ContractInformation = "Infor. de Contrato",
  MarriageCertificate = "Certidão de Casamento",
  BankInfo = "Dados Bancários",
  ContractSignature = "Ass. de Contrato",
  LegalCertificates = "Envio de Certidões",
  Compliance = "Compliance",
  Diligence = "Diligência",
  SpecialSituation = "Aprovação Special",
  Attorney = "Procuração",
  Funding = "Payment",
  Payment = "Pagamento"
}

export enum TradePhaseTranslation {
  Undefined = "Indefinido",
  SellChoice = "Venda Iniciada",
  DocumentValidation = "Validação de Documento",
  DocumentApproval = "Aprovação de Documento",
  ContractInformation = "Informações de Contrato",
  BankInfo = "Informações Bancárias",
  MarriageCertificate = "Certidão de Casamento",
  ContractSignature = "Assinatura de Contrato",
  LegalCertificates = "Certidões Legais",
  Diligence = "Diligência",
  SpecialSituation = "Aprovação Special",
  Attorney = "Procuração",
  Funding = "Payment",
  Payment = "Pós-Compra"
}

export interface ITradePhaseTranslation {
  name: string;
  alias: string;
  key: number;
}

export const SelectTradePhaseTranslation: ITradePhaseTranslation[] = [
  {
    name: "SellChoice",
    alias: "Venda Iniciada",
    key: 1
  },
  {
    name: "DocumentValidation",
    alias: "Validação de Documento",
    key: 2
  },
  {
    name: "Compliance",
    alias: "Compliance",
    key: 3
  },
  {
    name: "DocumentApproval",
    alias: "Aprovação de Documento",
    key: 4
  },
  {
    name: "ContractInformation",
    alias: "Informações de Contrato",
    key: 5
  },
  {
    name: "ContractSignature",
    alias: "Assinatura de Contrato",
    key: 6
  },
  {
    name: "LegalCertificates",
    alias: "Certidões Legais",
    key: 7
  },
  {
    name: "Diligence",
    alias: "Diligência",
    key: 8
  },
  {
    name: "SpecialSituation",
    alias: "Aprovação Special",
    key: 9
  },
  {
    name: "Attorney",
    alias: "Procuração",
    key: 10
  },
  {
    name: "Funding",
    alias: "Payment",
    key: 11
  },
  {
    name: "Payment",
    alias: "Pós-Compra",
    key: 12
  }
];

export enum TradePhaseMonitoring {
  SellChoice = "SellChoice",
  DocumentValidation = "Validação de Documento",
  DocumentApproval = "Aprovação de Documento",
  ContractInformation = "Infor. de Contrato",
  BankInfo = "Dados Bancários",
  ContractSignature = "Ass. de Contrato",
  LegalCertificates = "Envio de Certidões",
  Diligence = "Diligência",
  Payment = "Pagamento"
}

export enum PropertyRegime {
  Indefinido = "Indefinido",
  ComunhaoParcial = "ComunhaoParcial",
  ComunhaoTotal = "ComunhaoTotal",
  SeparacaoTotal = "SeparacaoTotal"
}

export enum PropertyRegimeDesc {
  Indefinido = "Selecione o regime de bens",
  ComunhaoParcial = "Comunhão Parcial de Bens",
  ComunhaoTotal = "Comunhão Total de Bens",
  SeparacaoTotal = "Separacão Total de Bens"
}

export enum UserType {
  Cliente = "Cliente",
  Officer = "Officer",
  Administrator = "Administrator",
  ClienteMigalhas = "ClienteMigalhas"
}

export enum PrecatorioClassification {
  Precatorio = "Precatorio",
  RPV = "RPV",
  Indefinido = "Indefinido"
}

export enum AccrualTypeEnum {
  SelicLinear = 0,
  Ipca = 1
}

export interface ICalculator {
  request: {
    dataExpedicao: Date;
    dataVencimento: Date;
    dataBase: Date;
    principal: number;
    juros: number;
    spread: number;
    tipoAccrual: AccrualTypeEnum;
    porcentagemDefault: number;
    porcentagemComissao: number;
    custoDesembolso: number;
    mesesParaLiquidacao: number;
    dataDesembolso: Date;
  };
  price: number;
  updatedPrecatorioValue: number;
  futurePrincipal: number;
}

export interface ICommonDomain {
  id: number;
  code: string;
  name: string;
  content: any;
  parentId?: number;
  order: number;
  canonical?: string;
  isActive: boolean;
  children: ICommonDomain[];
}

export interface ICorrectionTableAll {
  id: number;
  tableName: string;
  rows: object;
}

export interface ICommonDomainList {
  value: ICommonDomain[];
  "@odata.nextLink"?: string;
  "@odata.count"?: string;
}

export enum OfficerProfilesAlias {
  Officer_Master = "Gerencial",
  Officer_Administrator = "Administrador",
  Officer_Operator = "Operador"
}

export enum responsibility {
  Owner,
  Spouse,
  lawyer
}

export enum BcheckTypeEnum {
  Compliance = "Compliance",
  Credit = "Credit",
  LawyerCompliance = "LawyerCompliance"
}



// WEBPACK FOOTER //
// ./src/services/interfaces/UserInterface.ts